import { createSlice } from "@reduxjs/toolkit";
import { countDeckSeats } from "../pages/SeatPlan/template/helper";

export const templateDecks = createSlice({
    name: "templateDecks",
    initialState: {
        decks: [],
        seatCount: {},
    },
    reducers: {
        setDecks(state, action) {
            state.decks = action.payload; //Decks array as payload
            state.seatCount = countDeckSeats(state.decks);
        },
        addDeck(state, action) {
            let payload = {...action.payload};
            if (payload?.template_seat_plan_id) {
                payload.seats = payload.seats.map(item => {
                    if (item?.template_deck_id) {
                        let seat = {...item}
                        delete seat.id
                        delete seat.template_deck_id
                        return seat;
                    }
                    return item;
                })
            }
            state.decks.push(payload); //Deck object as payload
            state.seatCount = countDeckSeats(state.decks);
        },
        removeDeck(state, action) {
            state.decks.splice(action.payload, 1); //Deck index as payload
            state.seatCount = countDeckSeats(state.decks);
        },
        updateDeck(state, action) {
            const { deckIndex, updatedDeck } = action.payload;
            state.decks = state.decks.map((deck, index) =>
                index !== deckIndex ? deck : updatedDeck
            );
            state.seatCount = countDeckSeats(state.decks);
        },
        updateSeat(state, action) {
            const { deckIndex, seatIndex, updatedSeat } = action.payload;
            state.decks = state.decks.map((deck, index) => {
                if (index !== deckIndex) return deck;
                return {
                    ...deck,
                    seats: deck.seats.map((seat, seatIdx) =>
                        seatIdx !== seatIndex ? seat : updatedSeat
                    ),
                };
            });
            state.seatCount = countDeckSeats(state.decks);
        },
        clearDecks(state, action) {
            state.decks = [];
            state.seatCount = {};
        },
    },
});

export const {
    setDecks,
    addDeck,
    updateDeck,
    updateSeat,
    removeDeck,
    clearDecks,
} = templateDecks.actions;

export default templateDecks.reducer;
